import { render } from "./Comp2.vue?vue&type=template&id=0a8d18b3&scoped=true&ts=true"
import script from "./Comp2.vue?vue&type=script&lang=ts"
export * from "./Comp2.vue?vue&type=script&lang=ts"

import "./Comp2.vue?vue&type=style&index=0&id=0a8d18b3&lang=css&scoped=true"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8d18b3"]])

export default __exports__